<template>
  <div class="page-mh p-15">
    <div class="zindex-9">
      <div v-if="$userInfo" class="flex flex-align-center mb-15">
        <img @click="toInfo" class="avatar" :src="$userInfo.avatar" alt="" />
        <div class="fz-20 c0 flex-1 ml-15">
          {{ $userInfo.nickname }},Карго899 рада приветствовать вас!
        </div>
      </div>
      <img
        class="h-banner mb-20 circle-10"
        src="@/assets/images/home-banner2.png"
        alt=""
      />
      <div class="serach-wrap mb-20">
        <img
          class="icon"
          src="@/assets/images/ic_search.png"
          alt=""
          srcset=""
        />
        <input
          class="flex-1 fz-12 c3 ml-10"
          type="text"
          name=""
          @confirm="handleSearch"
          v-model="keyword"
          placeholder="Номер накладной"
        />

        <div @click="reget" class="btn">Поиск</div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="больше нет"
        loading-text="Загруска..."
        @load="getList"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="bg-f circle-10 plr-30 ptb-20 mb-12"
          @click="jump(item.id)"
        >
          <div class="flex flex-align-center mb-15">
            <div class="fz-15 c3">{{ item.ship_address }}</div>
            <img
              class="img-20 ml-10 mr-10"
              src="@/assets/images/right-icon.png"
              alt=""
              srcset=""
            />
            <div class="fz-15 c3 flex-1">
              {{ item.destination }}{{ item.delivery_address }}
            </div>
          </div>
          <div class="flex mb-10">
            <div class="fz-13 c9 w-150">Номер накладной</div>
            <div class="c3 fz-13 flex-1">{{ item.order_sn }}</div>
          </div>
          <div class="flex mb-10">
            <div class="fz-13 c9 w-150">Статус доставки груза</div>
            <div class="c3 fz-13 flex-1">{{ statusArr[item.status] }}</div>
          </div>
          <div class="flex">
            <div class="fz-13 c9 w-150">Дата отправки</div>
            <div class="c3 fz-13 flex-1">{{ item.delivery_date }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {
      keyword: "",
      list: [],
      page: 1,
      loading: false,
      finished: false,
      statusArr: {
        10: "Не отправлено",
        20: "Отправлено",
        25: "На таможне",
        30: "Таможенное оформление",
        40: "Отправлен на склад в город Москва",
        45: "Прибыл на склад в город Москва",
        50: "Ожидает дальнейшей транспортировки ",
        60: "В пути",
        99: "99",
      },
    };
  },
  computed: {
    ...mapState(["$userInfo"]),
  },
  created() {
    this.$http
      .post("/api/user/getInfo")
      .then((res) => {
        this.setLoginSuccess(res.data);
        this.setUserInfo(res.data);
      })
      .catch((e) => {
        console.error(e);
      });
  },
  methods: {
    toInfo() {
      this.$router.push({
        name: "user",
      });
    },
    jump(id) {
      this.$router.push({
        name: "detail",
        query: {
          id,
        },
      });
    },
    reget() {
      if (this.loading) return;
      this.page = 1;
      this.finished = false;
      this.getList()
    },
    async getList() {
      try {
        let { data, code, msg } = await this.$http.get("/api/order/list", {
          params: {
            page: this.page,
            limit: 10,
            keywords: this.keyword,
          },
        });

        if (code != 1) {
          this.$toast(msg);
          return;
        }
        this.loading = false;
        if (this.page === 1) {
          this.list = data.data;
        } else {
          this.list = [...this.list, ...data.data];
          this.page++;
        }
        if (data.total >= this.list.length) {
          this.finished = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleSearch(e) {
      console.log(e);
    },
    ...mapMutations(["setLoginSuccess", "setUserInfo"]),
  },
};
</script>

<style lang="less">
.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: transparent;
}
.h-banner {
  width: 100%;
  height: 192px;
}

.serach-wrap {
  height: 35px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 35px;
  padding: 0 10px 0 15px;
  .icon {
    width: 15px;
    height: 15px;
  }
  .btn {
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    background: #ea4335;
    border-radius: 15px;
    color: #ffffff;
  }
}
</style>
